<template>
  <layout kind="one_column" id="customers-subject-new">
    <v-container fluid pt-0 mt-0 pb-0>
      <v-layout row wrap>
        <v-flex xs12 mb-3 v-if="document_type !== '' && operation == 'create'">
          <h1 class="max">{{i18n('Criar Cadastro')}}</h1>
        </v-flex>
        <v-flex xs12 mb-3 v-if="document_type !== '' && operation == 'update'">
          <h1 class="max">{{i18n('Cadastro')}}</h1>
        </v-flex>
        <v-flex xs12 mb-3 v-if="operation == 'create'">
          <div class="select-document-type">
            <span style="align-items: center; justify-content: center; display:inline-flex;">
              <v-radio-group v-model="document_type" row>
                <v-radio color="#27DABC" :label="i18n('Pessoa Física')" value="cpf"></v-radio>
                <v-radio color="#27DABC" :label="i18n('Pessoa Jurídica')" value="cnpj"></v-radio>
              </v-radio-group>
            </span>
          </div>
        </v-flex>
        <v-flex xs12 v-if="document_type !== '' && document_type !== 'select'">
          <company-form :subject="true" :operation="operation" @onCreate="onCreate" :record="record" v-if="isCompany" />
          <person-form  :subject="true" :operation="operation" @onCreate="onCreate" :record="record" v-if="isPerson" />
        </v-flex>
        <v-flex xs12 class="text-xs-center" v-if="document_type !== '' && document_type !== 'select' && operation == 'update'">
          <v-btn class="flex-1 font-weight-black btn-bg-color text-color-white" @click="resetForm" style="width: 100%; margin: 0px;">
            {{ i18n('Novo Cadastro') }}
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </layout>
</template>

<script>
import LeftBarLayout from "./layouts/LeftBarLayout"
import AdminCompanyForm from "./AdminCompanyForm"
import AdminPersonForm from "./AdminPersonForm"
import Title from "./components/Title"
import utils from "./shared/Utils"

export default {
  name: 'CustomersSubjectsNew',
  components: { layout: LeftBarLayout, 'company-form': AdminCompanyForm, 'person-form': AdminPersonForm, 'page-title': Title },
  data: () => {
    return {
      document_type: 'cpf',
      operation: 'create',
      record: {
        document_type: 'cpf',
        document_number: '',
        references: [],
        documents: []
      }
    }
  },
  mounted () {
    this.$root.authenticationStore.redirectIfNotAuthenticated()
  },
  computed: {
    isPerson() {
      return utils.personDocumentTypes.includes(this.document_type.toLowerCase())
    },
    isCompany() {
      return utils.companyDocumentTypes.includes(this.document_type.toLowerCase())
    }
  },
  watch: {
    document_type(val, old_val) {
      if ((val !== old_val) &&
          ((val == 'cpf' && old_val == 'cnpj') ||
          (val == 'cnpj' && old_val == 'cpf'))) {
        this.$set(this.record, 'document_type', val)
      }
    }
  },
  methods: {
    i18n(str) {
      return this.$root.l(str)
    },
    resetForm() {
      this.operation = 'create'
      this.record = {
        document_type: 'cpf',
        document_number: '',
        references: [],
        documents: []
      }
    },
    onCreate(created_record) {
      this.operation = 'update'
      this.record = created_record
    }
  },
  metaInfo: {
    title: "Facilita Pay"
  }
}
</script>

<style>
.btn-bg-color {
  background-color: var(--primary-button-background-color) !important;
}
.text-color-white{
  color: white !important;
}
.flex-1 {
  flex: 1;
}
#customers-subject-new .select-document-type {
  display: flex;
  justify-content: center;
}
#customers-subject-new .select-document-type label{
  color: #BCC1D1 !important;
}
</style>



// WEBPACK FOOTER //
// src/CustomersSubjectsNew.vue